<div 
  class="bg-light-orange w-full maxh-550-px overflow-x-auto w-table table-scroll"
>
  <div class="data-table4  mt-3 barlow" style="font-size: 10px;">
    <table class="w-max min-w-full whitespace-nowrap" [class.sticky-last]="stickyLastColumn">
      <thead class="capitalize">
        <!-- Top Group Headers -->
        <tr>
          @if (tableHeader?.length > 0) {
            @for (header of tableHeader; track $index) {
              <td
                class="text-left barlow pl-2 pt-3 pb-3 font-bold"
                style="border-top: 1px #CAC2BC solid;"
                [attr.colspan]="header.colspan || 1"
                [ngStyle]="{ 'border-right': $index === tableHeader.length - 1 ? 'none' : '2px #CAC2BC solid' }"
              >
                {{ header.label }}
              </td>
            }
          }
        </tr>

        <!-- Subheaders -->
        <tr>
          @if (tableSubHeader?.length > 0) {
            @for (subHeader of tableSubHeader; track $index) {
              <th
                class="barlow pt-3 pb-3 font-bold"
                [class.text-center]="subHeader.centered"
                [class.text-left]="!subHeader.centered"
                [ngStyle]="{
                  'padding-left': '8px',
                  'padding-right': '8px',
                  'min-width': subHeader.minWidth || defaultMinWidth,
                  'border-top': subHeader.noTopBorder ? 'none' : '1px #CAC2BC solid',
                  'border-right': $index === tableSubHeader.length - 1 ? 'none' : '2px #CAC2BC solid'
                }"
              >
                <div
                  class="flex items-center gap-2"
                  [class.justify-center]="subHeader.centered"
                  [class.justify-between]="!subHeader.centered"
                >
                  <span [innerHTML]="subHeader.label"></span>
                  @if (isSortable(subHeader)) {
                    <img
                      src="../../../../../assets/images/icon/sort2.webp"
                      class="flex-shrink-0"
                      style="height:15px; cursor: pointer;"
                      (click)="sortList(subHeader.key, sort_type)"
                      alt="Sort"
                    />
                  }
                </div>
              </th>
            }
          }
        </tr>
      </thead>

      <!-- Body with projected content -->
      <tbody [class.text-center]="centeredContent">
        <ng-container *ngIf="!isLoading; else loadingState">
          <ng-content></ng-content>
        </ng-container>

        <ng-template #loadingState>
          <tr>
            <td [attr.colspan]="tableSubHeader?.length || 12" class="text-center py-4 h-250-px text-gray-500 italic">
              Loading data, please wait...
            </td>
          </tr>
        </ng-template>
      </tbody>
    </table>
  </div>
</div>